/*
 * @Author: your name
 * @Date: 2021-01-14 10:48:29
 * @LastEditTime: 2021-09-27 10:23:06
 * @LastEditors: yang chenglin
 * @Description: In User Settings Edit
 * @FilePath: \CJYX_DouYin\src\pages\Home\components\ParagraphTitle\index.tsx
 */
import React, { useEffect } from 'react';

const ParagraphTitle = ({ title, subtitle }) => {
  useEffect(() => {
  }, []);

  return (
    <section style={{ marginBottom: subtitle ? 12 : 20 }}>
      <div style={{ fontSize: 18, fontWeight: 'bold', color: '#333333' }}>{title}</div>
      {
        subtitle &&
        <div style={{ fontSize: 12, fontWeight: 500, color: '#9CA7B6', marginTop: 8 }}>{subtitle}</div>
      }
    </section>
  );
};
export default ParagraphTitle;
